module.exports = __webpack_public_path__ + "img/7.62a150ca.jpg";